"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.01 14.872q-2.337.002-4.674-.001c-.641-.001-1.12-.294-1.394-.87-.278-.584-.222-1.156.189-1.666.126-.158.296-.28.45-.414.38-.325.575-.736.576-1.235q.004-1.356 0-2.711c-.001-.767.135-1.507.479-2.195.746-1.496 1.935-2.43 3.59-2.707 1.524-.255 2.879.16 4.025 1.194.904.813 1.42 1.841 1.562 3.05a7 7 0 0 1 .038.809q.007 1.25 0 2.503c-.004.552.201 1 .637 1.34.271.212.51.446.638.776.372.963-.291 2.128-1.431 2.127zm-.009 2.127c-.45 0-.9.003-1.348-.002-.525-.005-.862-.49-.663-.955.11-.259.315-.413.598-.415q1.415-.01 2.832 0a.667.667 0 0 1 .654.636.676.676 0 0 1-.578.72q-.097.014-.195.015h-1.3"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertFillIcon20.js.map